import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
    rootBox:{
        '&.MuiGrid-root':{
            // backgroundColor:"#f3ccf330",
            // height:"calc(100vh - 20vh)",
            borderRadius:"5px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            padding:"20px 50px"
            // display:"flex",
            // justifyContent:"center",
            // alignItems:"center"
        }
    },
    customtextfield: {
        "&.MuiTextField-root": {
          width: "220px",
          marginBlockStart: "5px",
          marginInlineEnd: "15px",
          marginBlockEnd:"10px",
        //   border:"1px solid darkviolet",
          borderRadius:"5px",
          [theme.breakpoints.down(728)]: {
            width: "100%",
          },
        },
      },
      flexBox:{
        '&.MuiGrid-root' :{
            display:"flex",
            justifyContent: "flex-end",
            alignItems: "center",
        }
      },
      text:{
        '&.MuiTypography-root':{
            fontWeight:"600",
            fontSize:18
        }
      }
}))
